<template>
  <div class="project-content">
    <el-table :data="list" class="project-table">
      <el-table-column label="序列" :width="hideDetermine?80:50" header-align="center" align="left">
        <template slot-scope="scope">
          <div class="index-cell">
            {{scope.$index + 1}}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="推荐项目" width="155" header-align="center" align="left" class-name="project-cell" sortable :sort-method="(a, b) => sortDevName(a.itemName, b.itemName)">
        <template slot-scope="scope">
          <label v-html="scope.row.itemName"></label>
          <span class="test-item-label" v-if="scope.row.labelName">{{scope.row.labelName}}</span>
          <span class="give-away-icon" v-if="scope.row.isGive === 1 || scope.row.originalPrice === 0">赠</span>
        </template>
      </el-table-column>
      <el-table-column label="测试样品" :width="hideDetermine?152:132" header-align="center" align="left" class-name="yangpin-cell">
        <template slot-scope="scope" v-if="scope.row.orderSampleDTOList && scope.row.orderSampleDTOList.length">
          <template v-if="scope.row.orderSampleDTOList.length === 1">
            <div class="yangpin-tab">
              <text-tooltip :content="`${scope.row.orderSampleDTOList[0].row}# ${scope.row.orderSampleDTOList[0].sampleName}`"></text-tooltip>
            </div>
          </template>
          <template v-if="scope.row.orderSampleDTOList.length === 2">
            <el-tooltip :disabled="scope.row.orderSampleDTOList[0].sampleName.length < 3" :content="scope.row.orderSampleDTOList[0].row + '# ' + scope.row.orderSampleDTOList[0].sampleName" placement="top-start">
              <div class="yangpin-tab">{{scope.row.orderSampleDTOList[0].row}}# {{scope.row.orderSampleDTOList[0].sampleName.slice(0, 3)}}<span v-if="scope.row.orderSampleDTOList[0].sampleName.length > 3">...</span></div>
            </el-tooltip>
            <el-tooltip :disabled="scope.row.orderSampleDTOList[1].sampleName.length < 3" :content="scope.row.orderSampleDTOList[1].row + '# ' + scope.row.orderSampleDTOList[1].sampleName" placement="top-start">
              <div class="yangpin-tab">{{scope.row.orderSampleDTOList[1].row}}# {{scope.row.orderSampleDTOList[1].sampleName.slice(0, 3)}}<span v-if="scope.row.orderSampleDTOList[1].sampleName.length > 3">...</span></div>
            </el-tooltip>
          </template>
          <template v-if="scope.row.orderSampleDTOList.length > 2">
            <el-tooltip :disabled="scope.row.orderSampleDTOList[0].sampleName.length < 3" :content="scope.row.orderSampleDTOList[0].row + '# ' + scope.row.orderSampleDTOList[0].sampleName" placement="top-start">
              <div class="yangpin-tab">{{scope.row.orderSampleDTOList[0].row}}# {{scope.row.orderSampleDTOList[0].sampleName.slice(0, 3)}}<span v-if="scope.row.orderSampleDTOList[0].sampleName.length > 3">...</span></div>
            </el-tooltip>
            <el-tooltip :disabled="scope.row.orderSampleDTOList[1].sampleName.length < 3" :content="scope.row.orderSampleDTOList[1].row + '# ' + scope.row.orderSampleDTOList[1].sampleName" placement="top-start">
              <div class="yangpin-tab">{{scope.row.orderSampleDTOList[1].row}}# {{scope.row.orderSampleDTOList[1].sampleName.slice(0, 3)}}<span v-if="scope.row.orderSampleDTOList[1].sampleName.length > 3">...</span></div>
            </el-tooltip>
            <el-tooltip placement="top-start">
              <div class="yangpin-tab">+{{scope.row.orderSampleDTOList.length - 2}}</div>
              <template slot="content">
                <div v-for="(item, index) in scope.row.orderSampleDTOList.slice(2)" :key="index">
                  {{item.row}}# {{item.sampleName}}
                </div>
              </template>
            </el-tooltip>
          </template>
        </template>
      </el-table-column>
      <el-table-column prop="standardCode" label="测试标准" min-width="140" header-align="center" align="left" sortable :sort-method="(a, b) => sortDevName(a.standardCode, b.standardCode)">
        <span slot-scope="scope" v-html="textareaWrap(scope.row.standardCode)"></span>
      </el-table-column>
      <el-table-column label="测试备注" :min-width="hideDetermine?132:102" header-align="center" align="left">
        <template slot-scope="scope">
          <span v-html="scope.row.testMemo"></span> <qs-tips :data="{memo: scope.row.memoExplain}"></qs-tips>
        </template>
      </el-table-column>
      <el-table-column label="是否判定" width="100" header-align="center" align="center" v-if="!hideDetermine">
        <template slot-scope="scope">
          <span>{{scope.row.isDetermine === 1 ? '是' : '否'}}</span>
        </template>
      </el-table-column>
      <el-table-column :label="'原价' + currencyText" width="142" header-align="center" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.originalPrice === ''">待定</span>
          <span v-else>{{scope.row.originalPrice}} {{scope.row.unit ? '/' + scope.row.unit : ''}}</span>
        </template>
      </el-table-column>
      <el-table-column label="周期要求" width="70" header-align="center" align="center" prop="urgentTypeShow"></el-table-column>
      <el-table-column label="数量" :width="hideDetermine?73:53" header-align="center" align="center" class-name="num-cell">
        <template slot-scope="scope">
          {{scope.row.buyNums}} <qs-tips v-if="scope.row.otherExplain" :data="{memo: scope.row.otherExplain.numExplain}"></qs-tips>
        </template>
      </el-table-column>
      <el-table-column label="" width="142" header-align="center" align="center">
        <template slot="header">
          小计{{currencyText}}<qs-tips :data="{memo: '测试项目小计=（项目原价+加急费用）折扣*数量'}"></qs-tips>
        </template>
        <template slot-scope="scope">
          <!--{{math.chain(Number(scope.row.originalPrice)).multiply(scope.row.buyNums).done().toFixed(2)}}-->
          <span v-if="scope.row.originalTotalPrice===''">待定</span>
          <span v-else>{{scope.row.totalPrice}}</span>
        </template>
      </el-table-column>
      <!--<el-table-column label="操作" width="73" header-align="center" align="center" v-if="operateRow">
        <template slot-scope="scope">
          <span class="add-item test-item-btn" v-if="scope.row.isOptional === 1 && scope.row.isDefault === 0" @click="addItem(scope.$index, scope.row)"><i class="el-icon-plus"></i>加入</span>
          <span class="del-item test-item-btn" v-if="scope.row.isOptional === 1 && scope.row.isDefault === 1" @click="delItem(scope.$index, scope.row)"><i class="el-icon-minus"></i>移出</span>
        </template>
      </el-table-column>-->
    </el-table>
  </div>
</template>

<script>
import { textareaWrap } from 'utils'
import TextTooltip from './TextTooltip.vue'
import QsTips from './QsTips.vue'
export default {
  name: 'TestItem',
  components: {
    TextTooltip,
    QsTips
  },
  props: {
    list: {
      type: Array,
      default() {
        return []
      }
    },
    toSelectTestItem: {
      type: Array,
      default() {
        return []
      }
    },
    selectedTestItem: {
      type: Array,
      default() {
        return []
      }
    },
    operateRow: {
      type: Boolean,
      default: false
    },
    currencyText: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      textareaWrap
    }
  },
  computed: {
    hideDetermine() {
      const hideDetermine = this.list.some(v => v.isDetermine === -1)
      this.$emit('update:hideDetermine', hideDetermine)
      return hideDetermine
    }
  },
  created() {
    console.log(this.list)
  },
  methods: {
    addItem(index, data) {
      data.isDefault = 1
      this.selectedTestItem.push(data)
      this.toSelectTestItem.some((v, i) => {
        if(v.itemId === data.itemId) {
          this.toSelectTestItem.splice(i, 1)
          return true
        }
      })
    },
    delItem(index, data) {
      console.log('删除项目');
      data.isDefault = 0
      this.toSelectTestItem.push(data)
      this.selectedTestItem.some((v, i) => {
        if(v.itemId === data.itemId) {
          this.selectedTestItem.splice(i, 1)
          return true
        }
      })
    },
    sortDevName(str1,str2) {
      let res = 0
      for (let i = 0; ;i++) {
        if (!str1[i] || !str2[i]) {
          res = str1.length - str2.length
          break
        }
        const char1 = str1[i]
        const char1Type = this.getChartType(char1)
        const char2 = str2[i]
        const char2Type = this.getChartType(char2)
        // 类型相同的逐个比较字符
        if (char1Type[0] === char2Type[0]) {
          if (char1 === char2) {
            continue
          } else {
            if (char1Type[0] === 'zh') {
              res = char1.localeCompare(char2)
            } else if (char1Type[0] === 'en') {
              res = char1.charCodeAt(0) - char2.charCodeAt(0)
            } else {
              res = char1 - char2
            }
            break
          }
        } else {
          // 类型不同的，直接用返回的数字相减
          res = char1Type[1] - char2Type[1]
          break
        }
      }
      return res
    },
    getChartType(char) {
      // 数字可按照排序的要求进行自定义，我这边产品的要求是
      // 数字（0->9）->大写字母（A->Z）->小写字母（a->z）->中文拼音（a->z）
      if (/^[\u4e00-\u9fa5]$/.test(char)) {
        return ['zh', 300]
      }
      if (/^[a-zA-Z]$/.test(char)) {
        return ['en', 200]
      }
      if (/^[0-9]$/.test(char)) {
        return ['number', 100]
      }
      return ['others', 1]
    }
  }
}
</script>

<style scoped lang="scss">
.test-item-label {
  background: #ca4300;
  color: #fff;
  padding: 0 5px;
  text-align: center;
  display: inline-block;
  border-radius: 5px;
  font-size: 12px;
}
.give-away-icon {
  display: inline-block;
  width:23px;
  height:23px;
  background:#ca4300;
  border-radius:50%;
  font-size:14px;
  font-weight:bold;
  color:rgba(255,255,255,1);
  line-height:23px;
  margin-left: 10px;
  text-align: center;
  box-sizing: border-box;
}
</style>
<style lang="scss">
  .project-table tr th, .project-table.el-table tr th.el-table__cell {
    background: #F6F6F6;
  }
  .project-table tr td, .project-table tr td.el-table__cell {
    border-bottom: none;
  }
  .project-table th > .cell {
    font-weight: bold!important;
    padding: 0;
  }
</style>
